import hellojs from '../../vendor/hello.js'

export default function(serverName) {
  return hellojs
    .init({
      imanage: {
        name: 'iManage Work',

        base: `https://${serverName}/auth/oauth2`,

        oauth: {
          version: 2,
          auth: `https://${serverName}/auth/oauth2/authorize`,
          grant: `https://${serverName}/auth/oauth2/token`,
          response_type: 'code',
          state_encoding: 'base64',
        },

        scope: {
        },

        scope_delim: ' ',
      }
    })

    // Initialize Driver instance
    .init(
      { imanage: window.Drupal.settings.INTEGRATIONS_IMANAGE_APP_ID },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
      }
    )('imanage'); // spawn an instance of the driver that one can call .login() on
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/iManageAuthenticator.jsx